export default __webpack_public_path__ + "static/media/email.83792d31.svg";